import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=2535444e&scoped=true"
import script from "./ProductWindow.vue?vue&type=script&lang=js"
export * from "./ProductWindow.vue?vue&type=script&lang=js"
import style0 from "./ProductWindow.vue?vue&type=style&index=0&id=2535444e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535444e",
  null
  
)

export default component.exports